/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    BROADCAST_ACTION_BUTTONS_PHASE1
 * Date:         2025-01-02
 * Modified By:  Cursor
 *
 * Description:
 * Phase 1: Create visual-only action buttons (Resend, Edit, Delete) that appear
 * on hover over broadcast rows in "My Broadcasts" tab. Buttons perform console.log
 * only in this phase. Implements 1-second hover delay and floating overlay design.
 *
 * File Size Check:
 * - New file: ~80 lines
 * - Limit: 200 lines (components)
 * - Decision: Proceed
 *
 * Related Screens / Modules:
 * - client/src/components/broadcast/BroadcastItemCard.tsx (will be modified)
 * - client/src/features/broadcast/pages/broadcasts-list/components/BroadcastActionButtons.module.scss
 */

// [2025-01-02] Action buttons: Three button component with icons
import React from 'react';
import styles from './BroadcastActionButtons.module.scss';

export interface BroadcastActionButtonsProps {
  onResend: () => void;
  onEdit: () => void;
  onDelete: () => void;
  isLoading?: boolean;
  visible: boolean;
}

export const BroadcastActionButtons: React.FC<BroadcastActionButtonsProps> = ({
  onResend,
  onEdit,
  onDelete,
  isLoading = false,
  visible,
}) => {
  return (
    <div 
      className={`${styles.actionButtons} ${visible ? styles.visible : ''}`}
      onClick={(e) => e.stopPropagation()}
    >
      {/* [2025-01-02] Resend button: Black background */}
      <button
        className={styles.resendBtn}
        onClick={(e) => {
          e.stopPropagation();
          onResend();
        }}
        disabled={isLoading}
        aria-label="Resend this broadcast"
        type="button"
      >
        <img src="/assets/resend.svg" alt="" className={styles.btnIcon} />
        <span>Resend</span>
      </button>

      {/* [2025-01-02] Edit button: Blue background */}
      <button
        className={styles.editBtn}
        onClick={(e) => {
          e.stopPropagation();
          onEdit();
        }}
        disabled={isLoading}
        aria-label="Edit this broadcast"
        type="button"
      >
        <img src="/assets/edit.svg" alt="" className={styles.btnIcon} />
        <span>Edit</span>
      </button>

      {/* [2025-01-02] Delete button: Red background */}
      <button
        className={styles.deleteBtn}
        onClick={(e) => {
          e.stopPropagation();
          onDelete();
        }}
        disabled={isLoading}
        aria-label="Delete this broadcast"
        type="button"
      >
        <img src="/assets/delete.svg" alt="" className={styles.btnIcon} />
        <span>Delete</span>
      </button>
    </div>
  );
};
